import React from 'react';
import Button from '../../../Components/commonButton/commonButton'
import TextField from '../../../Components/textField/textField';
import Api from '../../../services/api';
import Alert from '../../../Components/alert/Alert'
import Select from '../../../Components/select/select';
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import '../general.css';

export default class AddDepartments extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            code: "",
            description: "",
            show: false,
            message: "",
            factorys: [],
            id_factorys: [],
            id_factory: null,
            readOnly: true,
            notification: false,
            notification_type: 'success',
            notification_message: ''
        }
    }

    componentDidMount() {
        Api.get('/factorys/').then(response => {
            let arr = []
            response.data.forEach(element => {
                arr.push({ value: element.id, label: element.description })
            })
            this.setState({ factorys: arr, id_factorys: [...response.data] })
        })
    }

    callBackDescription = (value) => { this.setState({ description: value }) }
    callBackCode = (value) => { this.setState({ code: value }) }

    sendData = () => {
        if ((this.state.id_factory !== null && this.state.id_factory !== "") && (this.state.code !== null && this.state.code !== "") && (this.state.description !== "" && this.state.description !== null)) {
            Api.post('/departments/', {
                code: this.state.code,
                description: this.state.description,
                id_factory: this.state.id_factory
            }).then((res) => {
                this.setState({notification: true, notification_message: "Setor cadastrado com sucesso!"});
                setTimeout(()=>{
                    return window.location.reload();
                },2000)
            }).catch((error) => {
                this.setState({ show: true, message: "Erro ao cadastrar departamento, verifique se os dados foram preenchidos corretamente." })
            })
        } else {
            this.setState({ show: true, message: "Necessário preencher todos os campos." })
        }
    }

    selectFactory = (value) => {
        const { id } = this.state.id_factorys.find(element => element.id === value)
        this.setState({ id_factory: id, readOnly: false })
    }
    callbackfunction = () => { this.setState({ show: false }) }

    render() {
        let { show, message, notification, notification_message, notification_type } = this.state;
        return (
            <div className="box">
                {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
                <div className="input_fields_add_depart form">
                    <h4>Adicionar Setor</h4>
                    {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} /> : null}
                    <div className='inputs'>
                        <div className='selectAddDepart element'><Select autoSelect={true} label="Parque Fabril" arrData={this.state.factorys} handleSelect={this.selectFactory} /></div>
                        <div className='tf1AddDepart element'><TextField section={true} title="Código" max={5} parentCallback={this.callBackCode} value={this.state.code} validationType="int" readOnly={this.state.readOnly} /></div>
                        <div className='tf2AddDepart element'><TextField title="Descrição do setor" min={3} max={30} parentCallback={this.callBackDescription} value={this.state.description} validationType="varchar" readOnly={this.state.readOnly} /></div>
                    </div>
                    <div className='btnAddDepart submitButton'><Button className="btn-fixed" title="Enviar" parentCallback={this.sendData} /></div>
                </div>
            </div>
        );
    }
}